import React from 'react';

const GiftSvg = props => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 1792 1792"
		{...props}
	>
		<path d="M1056 1356V640H736v716q0 25 18 38.5t46 13.5h192q28 0 46-13.5t18-38.5zM600 512h195L669 351q-26-31-69-31-40 0-68 28t-28 68 28 68 68 28zm688-96q0-40-28-68t-68-28q-43 0-69 31L998 512h194q40 0 68-28t28-68zm376 256v320q0 14-9 23t-23 9h-96v416q0 40-28 68t-68 28H352q-40 0-68-28t-28-68v-416h-96q-14 0-23-9t-9-23V672q0-14 9-23t23-9h440q-93 0-158.5-65.5T376 416t65.5-158.5T600 192q107 0 168 77l128 165 128-165q61-77 168-77 93 0 158.5 65.5T1416 416t-65.5 158.5T1192 640h440q14 0 23 9t9 23z" />
	</svg>
);

export default GiftSvg;
